import './globals.css';
import { AuthProvider } from './contexts/AuthContext';
import { LocalStorageProvider } from './contexts/LocalStorageContext';
import { createRoot } from 'react-dom/client';
import { CssVarsProvider } from '@mui/joy/styles';
import { Box, Link, Typography } from '@mui/joy';
import { Link as RouterLink } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import CssBaseline from '@mui/joy/CssBaseline';
import InitColorSchemeScript from '@mui/joy/InitColorSchemeScript';
import { theme } from '@/utils/theme';

// Create a new router instance
const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Typography level='h1'>La página que buscas no existe</Typography>
        <Link component={RouterLink} to={`/`}>
          Volver al inicio
        </Link>
      </Box>
    );
  },
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Create a client for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 3,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <>
    <InitColorSchemeScript />
    <QueryClientProvider client={queryClient}>
      <LocalStorageProvider>
        <AuthProvider>
          <CssVarsProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
          </CssVarsProvider>
        </AuthProvider>
      </LocalStorageProvider>
    </QueryClientProvider>
  </>
);
